/* <hero-slider-mto> özel elemanı. hero-slider-mto ve hero-slider-banner-mto section'ları ortak kullanır.
   Shopify {% javascript %} yalnızca sayfada o section'ın kendisi varsa yüklendiği için ayrı dosya. */
  if (!customElements.get('hero-slider-mto')) {
    class HeroSliderMto extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.hero-slider-mto__slide')];
        this.dots = [...this.querySelectorAll('.hero-slider-mto__dot')];
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go), true)));

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
        this.speed = Math.max(2, Number(this.dataset.speed) || 6) * 1000;

        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());

        let startX = null;
        this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
          startX = null;
        });

        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.go(i, false); this.pause(); }
        });
        this.addEventListener('shopify:block:deselect', () => this.resume());

        this.start();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      go(n, user) {
        const len = this.slides.length;
        this.index = ((n % len) + len) % len;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => {
          const active = i === this.index;
          dot.classList.toggle('is-active', active);
          dot.classList.remove('is-running');
          if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        if (user || !this.paused) this.start();
      }

      start() {
        clearTimeout(this.timer);
        if (!this.autoplay) return;
        this.paused = false;
        this.classList.remove('is-paused');
        const dot = this.dots[this.index];
        if (dot) {
          dot.classList.remove('is-running');
          void dot.offsetWidth;
          dot.classList.add('is-running');
        }
        this.remaining = this.speed;
        this.startedAt = Date.now();
        this.timer = setTimeout(() => this.go(this.index + 1, false), this.remaining);
      }

      pause() {
        if (!this.autoplay || this.paused) return;
        this.paused = true;
        this.classList.add('is-paused');
        clearTimeout(this.timer);
        this.remaining = Math.max(0, this.remaining - (Date.now() - this.startedAt));
      }

      resume() {
        if (!this.autoplay || !this.paused) return;
        this.paused = false;
        this.classList.remove('is-paused');
        this.startedAt = Date.now();
        this.timer = setTimeout(() => this.go(this.index + 1, false), this.remaining);
      }
    }
    customElements.define('hero-slider-mto', HeroSliderMto);
  }
